<script setup>
    import { computed, onMounted, reactive, ref, watch } from 'vue';
    import { useCommonStore } from '@/stores/common';
    import axios from 'axios';

    const store = useCommonStore();
    const ctEndPoint = ref(store.customerThermometerURL);
    const imgURL = ref(store.cloudfrontImgURL);
    const statsBackground = computed(() => `url('${imgURL.value}infographics-background.png')`);
    const fum = ref(0);
    const clients = ref(0);
    const ctScore = ref(0);
    const tweened = reactive({
        fum: 0,
        clients: 1900,
        ctScore: 0
    });

    async function getClientSatisfactionScore() {
        var ct = '95.0%';
        await axios.get(ctEndPoint.value)
            .then(res => {
                ct = res.data;
            })
            .catch(err => {
                console.log(err);
            })    

        const ctInt = parseFloat(ct.slice(0,ct.length-1));
        if(ctInt > 90) {
            return ctInt;
        } else {
            return 90;
        }
    }

    watch(fum, (n) => {
        gsap.to(tweened, { duration: 1.0, fum: Number(n) || 0})
    });
    watch(clients, (n) => {
        gsap.to(tweened, { duration: 1.0, clients: Number(n) || 1998})
    });
    watch(ctScore, (n) => {
        gsap.to(tweened, { duration: 1.0, ctScore: Number(n) || 0})
    });

    async function loadStatsValues() {
        const ct = await getClientSatisfactionScore();
        fum.value = 1000;
        clients.value = 1998;
        ctScore.value = ct;
    }

    onMounted(() => {
        loadStatsValues();
    });
</script>

<template>
    <div id="homepage-clarity-stats" class="content-center">
        <div id="homepage-clarity-stats-content" class="grid xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-2 grid-cols-1">
            <div>
                <h1 v-if="tweened.fum < 1000" class="clarity-h1-white text-center">£{{ tweened.fum.toFixed(0) }}<span style="text-transform: lowercase;">m+</span></h1>
                <h1 v-else class="clarity-h1-white text-center">£1<span style="text-transform: lowercase;">bn+</span></h1>
                <h3 class="clarity-h3-white text-center">FUNDS UNDER MANAGEMENT</h3>
            </div>
            <div class="xl:block lg:hidden hidden">
                <h1 class="clarity-h1-white text-center">{{ tweened.clients.toFixed(0) }}</h1>
                <h3 class="clarity-h3-white text-center">Established In</h3>
            </div>
            <div>
                <h1 class="clarity-h1-white text-center">{{ tweened.ctScore.toFixed(0) }}%</h1>
                <h3 class="clarity-h3-white text-center">CLIENT SATISFACTION RATE</h3>
            </div>
        </div>
    </div>
</template>

<style lang="css" scoped>
    #homepage-clarity-stats {
        max-width: 100%;
        background-image: v-bind(statsBackground);
    }
    #homepage-clarity-stats-content {
        padding-top: 45px;
        padding-bottom: 45px;
        padding-left: calc(15%);
        padding-right: calc(15%);
    }
    #homepage-clarity-stats .grid {
        margin-right: 0px !important;
    }
    #homepage-clarity-stats h3 {
        font-size: 22px;
    }
    @media only screen and (max-width: 1224px) {
        #homepage-clarity-stats-content {
            padding-left: calc(9%);
            padding-right: calc(9%);
        }
    }
    @media only screen and (max-width: 767px) {
        #homepage-clarity-stats-content {
            padding-left: 20px;
            padding-right: 20px;
        }
    }
</style>